import React from 'react'

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

// wrappers for prime react form fields
import FieldInputText from '../common/FieldInputText'

const CandidateBoardDetailsDialogFooter = ({ submitForm, updateForm, isAdd, canSave, deleteCandidateBoard, 
     currentCandidateBoard, closeCandidateBoardDetails,isAdmin,confirmDeleteCandidateBoard,deleteBoard }) => {
  let addOrUpdate = isAdd ? "Add": "Update"
  let showAsTextOnly = canSave === false

  return (
    <React.Fragment>
      {showAsTextOnly===false && deleteBoard === false && <Toolbar>
        <div className="p-toolbar-group-left">
          <Button id='endSentinel' style={{margin:"5px"}} label={addOrUpdate} icon="pi pi-check" onClick={submitForm} />
        </div>
        {<div className="p-toolbar-group-right">
          {isAdd === false && <Button style={{margin:"5px"}} icon="pi pi-times" label="Delete" onClick={() => confirmDeleteCandidateBoard(currentCandidateBoard.CandidateBoardDetailsId)} />}
        </div>}
      </Toolbar>}
      { deleteBoard && <Toolbar>
        <div className="p-grid" style={{textAlign:"left"}}>
            <div className="p-col-12">
              <label>Do you want to Delete this board?</label>
            </div>
            <div className="p-col-12">
              <div className="p-toolbar-group-left">
                  <Button style={{margin:"5px"}} icon="pi pi-check" label="Yes" onClick={() => deleteCandidateBoard(currentCandidateBoard.CandidateBoardDetailsId)} />
              </div>
              <div className="p-toolbar-group-right">
                  <Button style={{margin:"5px"}} icon="pi pi-times" label="No" onClick={() => closeCandidateBoardDetails()} />
              </div>
            </div>
        </div>
         </Toolbar> }
    </React.Fragment>
  )
}


const CandidateBoardDetails = ({ currentCandidateBoard, canSave, submitForm, updateForm, resetForm, isAdd, 
deleteCandidateBoard, isDisplayingDialog, closeCandidateBoardDetails, isAdmin,confirmDeleteCandidateBoard,deleteBoard }) => {
  let validationRules = currentCandidateBoard.ValidationRules ? currentCandidateBoard.ValidationRules.$values : []
  let showAsTextOnly = canSave === false
  if(deleteBoard)
  {
    showAsTextOnly = true;
  }

  const setEndFocus = () => {
    document.querySelector('#endSentinel').focus();
   };

   const setStartFocus = () => {
    document.querySelector('#boardDetailsDialog .p-dialog-titlebar a').focus();
   };


  let dialogFooter = <CandidateBoardDetailsDialogFooter submitForm={submitForm} updateForm={updateForm} isAdd={isAdd} 
  canSave={canSave} deleteCandidateBoard={deleteCandidateBoard} currentCandidateBoard={currentCandidateBoard} 
  isAdmin={isAdmin}  closeCandidateBoardDetails={closeCandidateBoardDetails} confirmDeleteCandidateBoard={confirmDeleteCandidateBoard} deleteBoard={deleteBoard}
   />
  return (
    <div id='boardDetailsDialog' >
    <Dialog style={{minWidth:'300px'}} visible={isDisplayingDialog} header={<strong>Board Details</strong>} modal={true} dismissableMask={true} footer={dialogFooter}
      onHide={() => { closeCandidateBoardDetails(resetForm) }} tabIndex="0" onFocus={setEndFocus}> 
      <div className="p-grid">
        <div className="p-col-12">
          <FieldInputText field={"BoardName"} label={"Board Name"}  tabIndex="0" aria-label="Board Name" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
         <div className="p-col-12">
          <FieldInputText field={"BoardPosition"} label={"Board Position"} tabIndex="0" aria-label="Board Position" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        { <div className="p-col-6">
          <FieldInputText field={"StartYear"} label={"Start Year"} tabIndex="0" aria-label="Start Year"  validationRules={validationRules} showAsTextOnly={showAsTextOnly}  />
        </div>}
        {<div className="p-col-6">
          <FieldInputText field={"EndYear"} label={"End Year"} tabIndex="0" aria-label="End Year"  validationRules={validationRules} showAsTextOnly={showAsTextOnly}  />
        </div>}
      </div>
    </Dialog>
    <span tabIndex="0" onFocus={setStartFocus}></span>
    </div>
  )
}

export default CandidateBoardDetails;


// WEBPACK FOOTER //
// ./src/components/candidateBoard/candidateBoard-details.js